import AjaxRequest from "../modules/ajax-request";

class Login {
    constructor(element) {
        this._div = element;
        this._formWrapper = "";
        this._renderLoginModalUrl = "";
        this._submitLoginFormUrl = "";
        this._renderRememberFormUrl = "";
        this._submitRememberFormUrl = "";
        this._accountPagePermalink = "";
        this._modal = "";
        this._loginForm = "";
        this._rememberForm = "";
        this._format = "";
        this._passwordInput = "";

        this.getData();
        this.clearData();
        this.bindEvents();
        this.init();
    }

    getData() {
        this._format = this._div.getAttribute('data-format');
        this._renderLoginModalUrl = this._div.getAttribute('data-render-login-modal-url');
        this._submitLoginFormUrl = this._div.getAttribute('data-submit-login-form-url');
        this._renderRememberFormUrl = this._div.getAttribute('data-render-remember-form-url');
        this._submitRememberFormUrl = this._div.getAttribute('data-submit-remember-form-url');
        this._accountPagePermalink = this._div.getAttribute('data-account-page-permalink');
    }

    clearData() {
        this._div.removeAttribute('data-format');
        this._div.removeAttribute('data-render-login-modal-url');
        this._div.removeAttribute('data-submit-login-form-url');
        this._div.removeAttribute('data-render-remember-form-url');
        this._div.removeAttribute('data-submit-remember-form-url');
        this._div.removeAttribute('data-account-page-permalink');
    }

    bindEvents() {
        let _this = this;
        if (this._format !== "form") {
            document.addEventListener("render_login_modal", function (event) {
                event.preventDefault();
                _this.renderLoginModal();
            });
        }
        if (this._format === "form") {
            document.addEventListener("user_logged", function (event) {
                event.preventDefault();
                if (_this._accountPagePermalink !== "") {
                    location.href = _this._accountPagePermalink;
                }
            });
        }
        this._div.addEventListener("click", function (event) {
            if (event.target.closest('[data-unmask-pwd]')) {
                event.preventDefault();
                _this.togglePasswordMask(event.target.closest('[data-unmask-pwd]'));
            }
        });
        this._div.addEventListener("click", function (event) {
            if (event.target.closest('[data-mask-pwd]')) {
                event.preventDefault();
                _this.togglePasswordMask(event.target.closest('[data-mask-pwd]'));
            }
        });
    }

    init() {
        this._formWrapper = "";
        this._modal = "";
        this._loginForm = "";
        this._rememberForm = "";
        if (this._format === "form") {
            this.bindsAfterRenderLoginModal();
        }
    }

    renderLoginModal() {
        let _this = this;
        if (this._modal === "") {
            let _ajaxRequest = new AjaxRequest({
                successCallback: function (response) {
                    _this._div.innerHTML = response.message;
                    _this._div.style.display = '';
                    _this.bindsAfterRenderLoginModal();
                }
            });
            _ajaxRequest.makeCall(this._renderLoginModalUrl);
        } else {
            this.showModal();
        }
    }

    renderRememberForm() {
        let _this = this;
        if (this._rememberForm === "") {
            let _ajaxRequest = new AjaxRequest({
                successCallback: function (response) {
                    _this._formWrapper.innerHTML = response.message;
                    _this.bindsAfterRenderRememberForm();
                }
            });
            _ajaxRequest.makeCall(this._renderRememberFormUrl);
        } else {
            this.showRememberForm();
        }
    }

    submitLoginForm(form) {
        let _this = this;
        let formData = new FormData(form);
        let serializedData = new URLSearchParams(formData).toString();
        let _ajaxRequest = new AjaxRequest({
            elementToAddLoading: form,
            successCallback: function (response) {
                _this._formWrapper.innerHTML = response.message;
                setTimeout(function () {
                    location.reload();
                }, 1000);
            },
            errorCallback: function (response) {
                _this._formWrapper.innerHTML = response.responseJSON.message;
            }
        });
        _ajaxRequest.makeCall(this._submitLoginFormUrl, serializedData);
    }

    submitRememberForm(form) {
        let _this = this;
        let formData = new FormData(form);
        let serializedData = new URLSearchParams(formData).toString();
        let _ajaxRequest = new AjaxRequest({
            elementToAddLoading: form,
            successCallback: function (response) {
                _this._formWrapper.innerHTML = response.message;
            },
            errorCallback: function (response) {
                _this._formWrapper.innerHTML = response.responseJSON.message;
            }
        });
        _ajaxRequest.makeCall(this._submitRememberFormUrl, serializedData);
    }

    bindsAfterRenderLoginModal() {
        let _this = this;
        if (this._format === "form") {
            this._formWrapper = this._div.querySelector('[data-id="widget-login_form-wrapper"]');
        } else {
            this._formWrapper = this._div.querySelector('[data-id="widget-login_modal_form_wrapper"]');
            this._modal = this._div.innerHTML;
        }
        this._passwordInput = this._div.querySelector("#login_login_form_password");
        this._loginForm = this._formWrapper.innerHTML;

        this._div.addEventListener("click", function (event) {
            if (event.target.closest('[data-id="widget-login_modal_close_button"]')) {
                event.preventDefault();
                _this.closeModal();
            }
        });
        this._div.addEventListener("click", function (event) {
            if (event.target.closest('[data-id="widget-login_render-remember-form"]')) {
                event.preventDefault();
                _this.renderRememberForm();
            }
        });
        this._div.addEventListener("submit", function (event) {
            if (event.target.matches('[name="login_login_form"]')) {
                event.preventDefault();
                _this.submitLoginForm(event.target);
            }
        });
    }

    bindsAfterRenderRememberForm() {
        let _this = this;
        if (this._format === "form") {
            this._formWrapper = this._div.querySelector('[data-id="widget-login_form-wrapper"]');
        } else {
            this._formWrapper = this._div.querySelector('[data-id="widget-login_modal_form_wrapper"]');
        }
        this._rememberForm = this._formWrapper.innerHTML;
        this._div.addEventListener("click", function (event) {
            if (event.target.closest('[data-id="widget-login_back-to-login"]')) {
                event.preventDefault();
                _this.showLoginForm();
            }
        });
        this._div.addEventListener("submit", function (event) {
            if (event.target.matches('[name="login_remember_form"]')) {
                event.preventDefault();
                _this.submitRememberForm(event.target);
            }
        });
    }

    showModal() {
        this._formWrapper.innerHTML = this._loginForm;
        // Replace fadeIn with opacity animation
        this._div.style.opacity = '0';
        this._div.style.display = '';
        setTimeout(() => {
            this._div.style.transition = 'opacity 0.1s ease-in-out';
            this._div.style.opacity = '1';
        }, 0);
    }

    closeModal() {
        this._div.style.transition = 'opacity 0.1s ease-in-out';
        this._div.style.opacity = '0';
        setTimeout(() => {
            this._div.style.display = 'none';
        }, 100);
    }

    showLoginForm() {
        this._formWrapper.innerHTML = this._loginForm;
        this._passwordInput = this._div.querySelector("#login_login_form_password");
    }

    showRememberForm() {
        this._formWrapper.innerHTML = this._rememberForm;
    }

    togglePasswordMask(element) {
        if (this._passwordInput.getAttribute("type") === "password") {
            this._passwordInput.setAttribute("type", "text");
        } else {
            this._passwordInput.setAttribute("type", "password");
        }
        element.style.display = 'none';
        element.classList.remove("is-active");
        let _buttonId = element.getAttribute('data-id');
        if (_buttonId === "mask") {
            let unmaskBtn = this._div.querySelector('[data-unmask-pwd]');
            if (unmaskBtn) {
                unmaskBtn.classList.add("is-active");
                unmaskBtn.style.display = '';
            }
        } else {
            let maskBtn = this._div.querySelector('[data-mask-pwd]');
            if (maskBtn) {
                maskBtn.classList.add("is-active");
                maskBtn.style.display = '';
            }
        }
    }
}

export default Login;